module.exports = require('./lib/marvel-ui-tooltip.js');



//////////////////
// WEBPACK FOOTER
// ./~/@marvelapp/marvel-ui/tooltip.js
// module id = 1119
// module chunks = 71833740541355